import { Layout as AntdLayout, type LayoutProps as AntdLayoutProps } from 'antd'

type ContentProps = AntdLayoutProps

export function Content(props: ContentProps) {
  return <AntdLayout.Content {...props} />
}
